import Vue from 'vue';
import App from './App';
import router from './router';
import Popover  from 'vue-js-popover';
import VueSession from 'vue-session';
import VueTheMask from 'vue-the-mask';
import VueUp from 'vueup';
var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo);
Vue.use(VueUp);
Vue.use(Popover);
Vue.use(VueSession);
Vue.use(VueTheMask);

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js